module.exports = {
	"data": {
		"markdownRemark": {
			"html": "<p>先祝各位新年快樂啦！（灑花</p>\n<p>今年過年期間時間很多，由於 DB 是北部人沒有返鄉的問題，初二固定舉辦的姑姑們回娘家聚餐也因故取消，就不用特別張羅這些事情。在家也沒事，大家也沒怎麼想出門，就是很閒啊~</p>\n<p>這麼多的時間，當然要拿來寫 code 還還技術債啊~</p>\n<h2 id=\"網站翻新\"><a href=\"#%E7%B6%B2%E7%AB%99%E7%BF%BB%E6%96%B0\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>網站翻新</h2>\n<p>首先，初二先花了半天的時間，將網站從裡到外整個翻新，外觀換成 Google 的 <a href=\"https://wcc723.gitbooks.io/google_design_translate/content/material-design-introduction.html\">Material Design</a> 設計風格，背後的 CMS 從 Ruby Based 的 <a href=\"https://jekyllrb.com/\">Jekyll</a> 換成 Node.js Based 的 <a href=\"https://www.gatsbyjs.org/\">GastbyJS</a>，順便串上 CI/CD 方便撰稿完一鍵部署。可以使用 React 開發就是舒暢，前陣子快被 WordPress 搞得很頭昏了，想要開發佈景主題 Theme 就一定會碰到 PHP ，這種感覺實在很令人不快（雖然我會寫 PHP，詳細的內容會放另外一篇討論。</p>\n<p>預計網站還會做以下的優化，敬請期待 XDD</p>\n<ul>\n<li>新建作品頁面，串接 Soundcloud 和 Sibelius Cloud</li>\n<li>整合 Facebook 留言功能（預設的 Disqus 去年爆出嚴重的個資外洩事件，不敢再用它了）</li>\n<li>支援 PWA，增進 mobile 的使用體驗</li>\n</ul>\n<p>說個題外話，Google 今年開始要捨棄 Chrome App ，全面改推 PWA 啦~ 各位 F2E 快跟上！！</p>",
			"timeToRead": 1,
			"excerpt": "先祝各位新年快樂啦！（灑花 今年過年期間時間很多，由於 DB 是北部人沒有返鄉的問題，初二固定舉辦的姑姑們回娘家聚餐也因故取消，就不用特別張羅這些事情。在家也沒事，大家也沒怎麼想出門，就是很閒啊~ 這麼多的時間，當然要拿來寫 code…",
			"frontmatter": {
				"title": "新年快樂! 除舊佈新",
				"cover": "https://i.imgur.com/Gq4KxCc.png",
				"date": "2018/02/18",
				"category": "talks",
				"tags": [
					"GastbyJS",
					"firebase",
					"react"
				]
			},
			"fields": {
				"nextTitle": "和聲學筆記 - I, V, and V7",
				"nextSlug": "/和聲學筆記-i-v-and-v-7",
				"prevTitle": "2017 台北音樂設計節 TMDF 筆記",
				"prevSlug": "/2017-台北音樂設計節-tmdf-筆記",
				"slug": "/新年快樂-除舊佈新"
			}
		}
	},
	"pathContext": {
		"slug": "/新年快樂-除舊佈新"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/新年快樂-除舊佈新.json
// module id = 521
// module chunks = 4623914800254